import { catchError, map, Observable, of, shareReplay } from 'rxjs';
import { IIPInfo } from '@content/contact-us/connect-with-our-team/connect-with-our-team.interfaces';
import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export class IpInfoService {
    private readonly http = inject(HttpClient);

    public readonly getIpInfo = this.http
        .get<IIPInfo>('https://ipapi.co/json/')
        .pipe(shareReplay(1));

    public getCountryCode(): Observable<string> {
        return this.getIpInfo.pipe(
            map(({ country_code }) => {
                return country_code;
            }),
            catchError(() => of('UA'))
        );
    }
}
